import { CustomerDetailLoyaltyInfoComponent } from './loyaltyinfo/loyaltyinfo.component';
import { CustomerLoyaltyInfo } from './../../../models/customer.model';
import { Permission } from './../../../models/permission.model';
import { CustomerInfoService } from './../../../services/customer/customerinfo.service';
import { CustomerDetailShoppingInfoComponent } from './shoppinginfo/shoppinginfo.component';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/components/common/api';
import { TranslateService } from '@ngx-translate/core';
import { CanComponentDeactivate } from '../../../services/utils/can-deactivate-guard.service';
import { CustomerDetailFamilyInfoComponent } from './familyinfo/familyinfo.component';
import { CustomerDetailBasicComponent } from './basicinfo/basic.component';
import { CustomerDetailHobbyPetInfoComponent } from './hobbypetinfo/hobbypetinfo.component';
import { isUndefined } from 'util';
import { PermissionConfiguration} from '../../../models/permission.model';
import { PermsService } from '../../../services/utils/perms.service';
import { ApiMethods } from '../../../models/permission.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { CustomerBasicInfo } from '../../../models/customer.model';
import { CustomerClustersComponent } from '../customer-clusters/customer-clusters.component';
import { HttpService } from '../../../modules/UIKit/components/spinnerLoading/httpServ.service';
import { Location } from '@angular/common';
import { ConfirmationService} from 'primeng/api';
import { CustomerClusterService } from '../../../services/customer/customer-cluster.service';
import { CustomerDetailServiceInfoComponent } from './serviceinfo/serviceinfo.component';
import { CustomerDetailBasicNewComponent } from './basicinfonew/basicnew.component';
import { CustomerCardListModel } from 'app/models/customer-cards.model';
import { CustomerChallengeInfoComponent } from './challenge/challengeinfo.component';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomerDetailComponent implements OnInit, CanComponentDeactivate {

  @ViewChild(CustomerDetailFamilyInfoComponent) customerDetailFamily: CustomerDetailFamilyInfoComponent;
  @ViewChild(CustomerDetailBasicComponent) customerDetailBasic: CustomerDetailBasicComponent;
  @ViewChild(CustomerDetailBasicNewComponent) customerDetailBasicNew: CustomerDetailBasicNewComponent;
  @ViewChild(CustomerDetailHobbyPetInfoComponent) customerDetailHobbyPerInfo: CustomerDetailHobbyPetInfoComponent;
  @ViewChild(CustomerClustersComponent) customerClustersComponent: CustomerClustersComponent;
  @ViewChild(CustomerDetailShoppingInfoComponent) customerShoppingComponent: CustomerDetailShoppingInfoComponent;
  @ViewChild(CustomerDetailServiceInfoComponent) customerDetailService: CustomerDetailServiceInfoComponent;
  @ViewChild(CustomerDetailLoyaltyInfoComponent) customerDetailLoyaltyInfo: CustomerDetailLoyaltyInfoComponent;
  @ViewChild(CustomerChallengeInfoComponent) customerChallengeInfoComponent: CustomerChallengeInfoComponent;

  public customerId: string = null;
  public editMode: boolean;


  /********************** PERMESSI UTENTE *************************/


  customerPermissions: Array<Permission>;
  loyaltyPermissions: Array<Permission>;
  promoPermissions: Array<Permission>;

  /*
    Richiama la cardInfo, cambiando la visualizzazione delle basic info del customer e
    nascondendo tutte le altre tab di info.
    Impedisce, inoltre, le chiamate alla loyaltyUpdate
  */
  public mdmCustomerPermission: boolean;
  public mdmCustomerPermissionCheck: PermissionConfiguration;

  // Inutilizzata
  public historyPermission: boolean;
  public customerHistoryPermissionCheck: PermissionConfiguration;

  // Visualizza tab info familiari
  public familyPermission: boolean;
  public customerFamilyPermissionCheck: PermissionConfiguration;

  // Visualizza tab servizi cliente
  public servicePermission: boolean = false;
  public customerServicePermissionCheck: PermissionConfiguration;

  // Visualizza tab hobby & pets
  public hobbyPetPermission: boolean;
  public customerHobbyPetPermissionCheck: PermissionConfiguration;

  // Visualizza tab liste della spesa
  public shoppingPermission: boolean;
  public customerShoppingPermissionCheck: PermissionConfiguration;

  // Visualizza tab carte
  public loyaltyPermission: boolean;
  public customerLoyaltyPermissionCheck: PermissionConfiguration;

  // Visualizza tab carte famiglia
  public familyCardPermission: boolean;
  public familyCardPermissionCheck: PermissionConfiguration;

  // Visualizza tab sfide 
  public challengePermission: boolean;
  public challengePermissionCheck: PermissionConfiguration;

  // Switch tra componenti generali e componenti specifici
  public customerMgPermission: boolean;
  public customerMgPermissionCheck: PermissionConfiguration;

  // Switch tra componenti generali e componenti specifici
  public showBtnSubstitutePermission: boolean;
  public showBtnSubstitutePermissionCheck: PermissionConfiguration;

  // Per indicare alla UI se deve considerare KLOY
  public customerKloyPermission: boolean;
  public customerKloyPermissionCheck: PermissionConfiguration;

  // Permission Crud per Customer Ext Analytics
  public customerExtClusterAnalytics: boolean;
  public extClusterAnalytics: PermissionConfiguration;

  public customerExt: boolean;
  public extCluster: PermissionConfiguration;

  // Permission CRUD per Coupon Manager
  public couponManagerPermission: boolean;
  public couponManagerPermissionCheck: PermissionConfiguration;

  // Permission CRUD per Catalogo Premi
  public catalogoPremiPermission: boolean;
  public catalogoPremiPermissionCheck: PermissionConfiguration;

  /****************************************************************/


  public basicInfo: CustomerBasicInfo = null;
  public cardInfo: CustomerCardListModel[] = [];

  private successMessage: string = null;
  private loadingSubscription;
  private dirtyFormData = false;
  private clusterChanged = false;
  private clusterQty: number;

  public cards: CustomerCardListModel[];

  titlePage = 'customerDetail.addNew';
  items: MenuItem[];
  activeTabIndex = 1;

  show = {
    reportButtonMg: false,
    loyaltyInfo: false,
    permissions: false,
    basic: false,
    uploadModule: false
  }

  activeTab = {
    basicInfo: null,
    familyInfo: null,
    serviceInfo: null,
    hobbyPetInfo: null,
    cardsInfo: null,
    clustersInfo: null,
    shoppingInfo: null,
    loyaltyInfo: null,
    challengesInfo: null,
    familyCard: null,
    // Nascosto tab Dati Analytics per la KS-3298
    // extRapInfo: null,
    customerModuleInfo: null,
    extClusterAnalytics: null,
    couponManager: null,
    catalogoPremi: null
  }

  FormMore: any;
  isLoading = true;

  private customerClusterCheck: boolean;

  mdmCustomerInfo: {
    name: string,
    surname: string,
    birthDate: string,
    address1: string,
    addressNumber: string,
    zipCode: string,
    city: string,
    province: string,
    email: string,
    currentCluster: string,
    cardState: string,
    expirationDate: string,
    telephone: string,
    mobile:string
  }

  missingClusterMsg: string;
  saveClusterMsg: string;
  dataLossMsg: string;
  errorTitle: string;
  errorSavingMsg: string;

  customerHasFiles: boolean;
  customerHasLoginAccount: boolean;

  customer_id: string;

  noCardsForCustomer: boolean = false;

  constructor (
    private router: Router,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private srvPerms: PermsService,
    private httpSrv: HttpService,
    private location: Location,
    private srvNotify: MessageService,
    private confirmationService: ConfirmationService,
    private clusterSrv: CustomerClusterService,
    private customerInfoSrv: CustomerInfoService
  ) {

    this.router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
    }

    this.mdmCustomerPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-mdm',
      method: ApiMethods.GET
    };

    this.customerHistoryPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-history',
      method: ApiMethods.GET
    };

    this.customerFamilyPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-family',
      method: ApiMethods.GET
    };

    this.customerServicePermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-service',
      method: ApiMethods.GET
    };

    this.customerHobbyPetPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-hobbypet',
      method: ApiMethods.GET
    };

    this.customerLoyaltyPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-loyalty',
      method: ApiMethods.GET
    };

    this.familyCardPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'card-familycard',
      method: ApiMethods.GET
    };

    this.customerMgPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-mg',
      method: ApiMethods.GET
    };

    this.showBtnSubstitutePermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'show-ui-substitute-card-btn',
      method: ApiMethods.GET
    };

    this.customerKloyPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-kloy',
      method: ApiMethods.GET
    };


    this.loadingSubscription = this.httpSrv.loading.subscribe({
      next: (event: boolean) => {
        console.log ('RICEVUTO EVENTO DI LOADING');
        if (!event && this.isLoading) {
          this.isLoading = false;
        }
      }
    });

    this.extClusterAnalytics = {
      ms_base: 'koncentro-customers',
      operation: 'customer-ext-cluster-analytics',
      method: ApiMethods.GET
    };

    this.extCluster = {
      ms_base: 'koncentro-customers',
      operation: 'customer-ext',
      method: ApiMethods.GET
    };

    this.customerShoppingPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'shopping',
      method: ApiMethods.GET
    };

    this.couponManagerPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-coupon',
      method: ApiMethods.GET
    };

    this.catalogoPremiPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'catalogo-premi-tab',
      method: ApiMethods.GET
    };

    this.challengePermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'challenges-list-gui',
      method: ApiMethods.GET
    }
  }


  canDeactivate(): Promise<boolean> | boolean {
    console.log('comp deact');
    return true;
  }

  ngOnInit() {
    this.FormMore = null;
    this.mdmCustomerPermission = false;
    this.historyPermission = false;
    this.familyPermission = false;
    this.servicePermission = false;
    this.hobbyPetPermission = false;
    this.shoppingPermission = false;
    this.familyCardPermission = false;
    this.customerMgPermission = false;
    this.customerKloyPermission = false;
    this.couponManagerPermission = false;
    this.catalogoPremiPermission = false;

    this.clusterSrv.getCustomerClusterCheckParam().subscribe(res => {
      this.customerClusterCheck = res.param_code && res.param_code === '1' ? true : false;
    });

    this.route.params.subscribe(params => {
      this.customerId = params['customerId'];

      if (params['customer_id']) {
        this.customer_id = params['customer_id'];
      }

      this.editMode = this.customerId !== undefined;

      if (this.editMode) {
        this.titlePage = 'customerDetail.edit';

        if (this.customer_id) {
          // Verifica che il cliente selezionato abbia un account di login
          this.customerInfoSrv.getCustomerAuthInfo(+this.customer_id).subscribe(res => {
            if (res && res.flg_state != '1') {
              this.customerHasLoginAccount = true;
            }
          });
        }


      } else {
        this.titlePage = 'customerDetail.addNew';
      }

      var LOYALTYPERMISSIONS = this.srvPerms.getLoyaltyPermission();
      var CUSTOMERPERMISSIONS = this.srvPerms.getCustomerPermission();
      var PROMOPERMISSIONS = this.srvPerms.getPromoPermission();
      var CARDS = this.customerInfoSrv.getCards(this.customerId);
      var TRANSLATIONS = this.translate.get([
        'customerInfoSheet.customerInfo',
        'customerInfoSheet.familyInfo',
        'customerInfoSheet.serviceInfo',
        'customerInfoSheet.hobbyPetInfo',
        'customerInfoSheet.loyaltyInfo',
        'customerInfoSheet.extRapInfo',
        'customerInfoSheet.customerModuleInfo',
        'customerInfoSheet.cardsInfo',
        'customerInfoSheet.familyCard',
        'customerInfoSheet.clustersInfo',
        'customerInfoSheet.history',
        'customerInfoSheet.cluster',
        'customerInfoSheet.shoppingInfo',
        'customerDetail.success',
        'customerInfoSheet.missingClusterMsg',
        'customerInfoSheet.saveClusterMsg',
        'customerInfoSheet.dataLossMsg',
        'common.error',
        'customerInfoSheet.errorSavingCustomer',
        'customerInfoSheet.customerExtAnalytics',
        'customerInfoSheet.couponManager',
        'customerInfoSheet.catalogoPremi',
        'customerInfoSheet.challengesInfo'
      ])

      Observable.zip(
        TRANSLATIONS,
        CUSTOMERPERMISSIONS,
        LOYALTYPERMISSIONS,
        PROMOPERMISSIONS,
        CARDS
      ).subscribe((
        [
          resTranslations,
          resCustomerPermissions,
          resLoyaltyPermissions,
          resPromoPermissions,
          resCards
        ]) => {
        this.errorTitle = resTranslations['common.error'];
        this.errorSavingMsg = resTranslations['customerInfoSheet.errorSavingCustomer'];

        this.customerPermissions = resCustomerPermissions;
        this.loyaltyPermissions = resLoyaltyPermissions;
        this.promoPermissions = resPromoPermissions;
        var self = this;

        if(resCards && resCards.length>0) {
          this.cards = resCards;
        }
        setTimeout(function(){
          self.show.loyaltyInfo = true;
        }, 100);
        this.mdmCustomerPermission = this.srvPerms.checkPermission(this.customerPermissions, this.mdmCustomerPermissionCheck);
        this.historyPermission = this.srvPerms.checkPermission(this.customerPermissions, this.customerHistoryPermissionCheck);
        this.familyPermission = this.srvPerms.checkPermission(this.loyaltyPermissions, this.familyCardPermissionCheck);
        this.hobbyPetPermission = this.srvPerms.checkPermission(this.customerPermissions, this.customerHobbyPetPermissionCheck);
        this.shoppingPermission = this.srvPerms.checkPermission(this.customerPermissions, this.customerShoppingPermissionCheck);
        this.loyaltyPermission = this.srvPerms.checkPermission(this.customerPermissions, this.customerLoyaltyPermissionCheck);
        this.familyCardPermission = this.srvPerms.checkPermission(this.customerPermissions, this.familyCardPermissionCheck);
        this.servicePermission = this.srvPerms.checkPermission(this.customerPermissions, this.customerServicePermissionCheck);
        this.customerMgPermission = this.srvPerms.checkPermission(this.customerPermissions, this.customerMgPermissionCheck);
        this.showBtnSubstitutePermission = this.srvPerms.checkPermission(this.customerPermissions, this.showBtnSubstitutePermissionCheck);
        this.customerKloyPermission = this.srvPerms.checkPermission(this.customerPermissions, this.customerKloyPermissionCheck);
        this.customerExtClusterAnalytics = this.srvPerms.checkPermission(this.customerPermissions, this.extClusterAnalytics);
        this.customerExt = this.srvPerms.checkPermission(this.customerPermissions, this.extCluster);
        this.couponManagerPermission = this.srvPerms.checkPermission(this.customerPermissions, this.couponManagerPermissionCheck);
        this.catalogoPremiPermission = this.srvPerms.checkPermission(this.customerPermissions, this.catalogoPremiPermissionCheck);
        this.challengePermission = this.srvPerms.checkPermission(this.loyaltyPermissions, this.challengePermissionCheck)
        this.show.permissions = true;

        if (this.mdmCustomerPermission) {
          let carta;
          if(params['cardNo'] == undefined) {
            CARDS.subscribe( (res) => {
              for (const c of res) {
                carta = c.cardNo;
                this.customerInfoSrv.getCustomerInfoByCardNo(carta).subscribe(
                  mdmCustomer => {
                    this.mdmCustomerInfo = {
                      name: mdmCustomer.name || null,
                      surname: mdmCustomer.surname || null,
                      birthDate: mdmCustomer.birthDate || null,
                      address1: mdmCustomer.address1 || null,
                      addressNumber: mdmCustomer.addressNumber || null,
                      zipCode: mdmCustomer.zipCode || null,
                      city: mdmCustomer.city || null,
                      province: mdmCustomer.province ? mdmCustomer.province.descr : null,
                      email: mdmCustomer.email || null,
                      currentCluster: mdmCustomer.currentCluster || null,
                      cardState: mdmCustomer.cardState || null,
                      expirationDate: mdmCustomer.expirationDate || null,
                      telephone: mdmCustomer.telephone || null,
                      mobile: mdmCustomer.mobile || null
                    }
                  }
                )
                break;
              }

            });
          }else{
            this.customerInfoSrv.getCustomerInfoByCardNo(params['cardNo']).subscribe(
              mdmCustomer => {
                this.mdmCustomerInfo = {
                  name: mdmCustomer.name || null,
                  surname: mdmCustomer.surname || null,
                  birthDate: mdmCustomer.birthDate || null,
                  address1: mdmCustomer.address1 || null,
                  addressNumber: mdmCustomer.addressNumber || null,
                  zipCode: mdmCustomer.zipCode || null,
                  city: mdmCustomer.city || null,
                  province: mdmCustomer.province ? mdmCustomer.province.descr : null,
                  email: mdmCustomer.email || null,
                  currentCluster: mdmCustomer.currentCluster || null,
                  cardState: mdmCustomer.cardState || null,
                  expirationDate: mdmCustomer.expirationDate || null,
                  telephone: mdmCustomer.telephone || null,
                  mobile: mdmCustomer.mobile || null
                }
              }
            )
          }
        }
        let counter = 0

        this.missingClusterMsg = resTranslations['customerInfoSheet.missingClusterMsg'];
        this.saveClusterMsg = resTranslations['customerInfoSheet.saveClusterMsg'];
        this.dataLossMsg = resTranslations['customerInfoSheet.dataLossMsg'];

        this.items = [
          {label: resTranslations['customerInfoSheet.customerInfo'] }
        ];

        this.activeTab.basicInfo = counter;

        if (this.customerId !== undefined) {

          if (this.familyPermission && !this.mdmCustomerPermission) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.familyInfo'] });
            this.activeTab.familyInfo = counter;
          }


          if (this.hobbyPetPermission && !this.mdmCustomerPermission) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.hobbyPetInfo'] });
            this.activeTab.hobbyPetInfo = counter;
          }


          //if(this.loyaltyPermission){
          counter++;
          this.items.push({ label: resTranslations['customerInfoSheet.cardsInfo'] });
          this.activeTab.loyaltyInfo = counter;
          //}

          // Carte Famiglia
          if (this.familyCardPermission) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.familyCard'] });
            this.activeTab.familyCard = counter;
          }

          if (this.servicePermission) {
            this.servicePermission = true;
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.serviceInfo'] });
            this.activeTab.serviceInfo = counter;
          }

          this.items.push(
            { label: resTranslations['customerInfoSheet.clustersInfo'] }
          );

          //counter++;
          //this.activeTab.cardsInfo = counter;

          counter++;
          this.activeTab.clustersInfo = counter;

          if (this.shoppingPermission && !this.mdmCustomerPermission) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.shoppingInfo'] });
            this.activeTab.shoppingInfo = counter;
          }

          // Nascosto tab Dati Analytics per la KS-3298
          /* if (!this.mdmCustomerPermission && !this.customerMgPermission) {
            counter++;
            this.items.push({label: resTranslations['customerInfoSheet.extRapInfo']});
            this.activeTab.extRapInfo = counter;
          } */

          if (this.customerMgPermission) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.customerModuleInfo'] });
            this.activeTab.customerModuleInfo = counter;
          }

          if (this.customerExtClusterAnalytics) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.customerExtAnalytics'] });
            this.activeTab.extClusterAnalytics = counter;
          }

          if (this.couponManagerPermission) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.couponManager'] });
            this.activeTab.couponManager = counter;
          }
          if (this.catalogoPremiPermission) {
            counter++;
            this.items.push({ label: resTranslations['customerInfoSheet.catalogoPremi'] });
            this.activeTab.catalogoPremi = counter;
          }
          if (this.challengePermission) {
            this.items.push({
              label: "Challenges"
            });
            this.activeTab.challengesInfo = ++counter;
          }
          this.successMessage = resTranslations['customerDetail.success'];
        }
        this.show.basic = true;
        this.show.uploadModule = true;

        if (this.route.snapshot.queryParamMap.get('tab')) {
          this.activeTabIndex = +this.route.snapshot.queryParamMap.get('tab');
        } else if (this.route.snapshot.paramMap.get('previousTab')) {
          this.activeTabIndex = +this.route.snapshot.paramMap.get('previousTab');
        } else {
          this.activeTabIndex = 0;
        }

      });
    });
  }

  onTabChange(index: number) {
    const url = this.router.createUrlTree([], {
      relativeTo: this.route,
      queryParams: { tab: index },
      queryParamsHandling: 'merge'
    }).toString();

    this.location.replaceState(url);
  }
  /* utilizzato (solo in Gabrielli) per la visualizzazione del pulsante sostituisci carta nel tab Carte.
    Il pulsante verrà visualizzato solo se tutti i campi obbligatori della scheda cliente sono presenti */
  allMandatoryFieldsOkLoaded(isOk: boolean) {
    if (isOk == true) {
      this.customerDetailLoyaltyInfo.allCustomerMandatoryFieldsOk = true;
    }
  }
  /**
   * In Gabrielli, se il cliente non ha un account di login, è obbligatorio il caricamento di un modulo (KS-3066)
   */
  checkCustomerLogin() {
    if (this.customerMgPermission && !this.customerHasLoginAccount && !this.customerHasFiles) {
      this.confirmationService.confirm({
        message: this.translate.instant('customers.fileRequiredMsg'),
        accept: () => this.save(),
        acceptLabel: this.translate.instant('common.yes'),
        rejectVisible: true,
        rejectLabel: 'NO',
        reject: () => false
      });
    } else {
      this.save();
    }
  }
  reloadTabUploadModules() {
    if (this.customerMgPermission) {
      this.show.uploadModule = false;
      var self = this;
      setTimeout(function () {
        self.show.uploadModule = true;
      }, 100);
    }
  }
  noCardLinked() {
    /*
    se non ci sono carte collegate al cliente, si deve informare l'utente, ma non farlo agire sulla scheda
    si torna quindi alla lista clienti
    */
    if (this.noCardsForCustomer == false && this.customerMgPermission) {
      this.noCardsForCustomer = true;
      var self = this;
      this.translate.get(['card.notAvailable']).subscribe(res => {

        this.srvNotify.add({ severity: 'error', summary: 'Error!', detail: res['card.notAvailable'] })
        setTimeout(function () {
          self.router.navigate(['/customers-infosheet-new']);
        }, 200);
      });
    }
  }
  cardSubstitutionDone() {
    //a seguito della sostituzione di una carta ricarica il modulo upload
    this.reloadTabUploadModules();
    this.refreshCards();
  }

  cardBlacklistDone() {
    //a seguito della blacklist di una carta ricarica il modulo upload
    this.reloadTabUploadModules();
    this.refreshCards();
    console.log('refreshedCard');
  }

  cardAddDone() {
    //a seguito dell'aggiunta di una carta ricarica il modulo upload
    this.reloadTabUploadModules();
    this.refreshCards();
  }
  save() {
    //controllo inibito nel caso di gabrielli, perciò valido solo per i "non gabrielli" (!this.customerMgPermission)
    if (this.customerClusterCheck && (this.checkActiveCard() && this.clusterQty == 0) && !this.customerMgPermission) {
      this.confirmationService.confirm({
        message: this.missingClusterMsg,
        accept: () => false,
        acceptLabel: "Ok",
        rejectVisible: false
      });
      return;
    }

    var self = this;

    if (isUndefined(this.customerId)) {
      if(this.customerMgPermission){
        this.customerDetailBasicNew.customSaveMg().subscribe(res => {
          if(res && res.id) {
            let customerCode: string = res.customerCode;
            if(this.customerDetailBasicNew.cardIdSelected > 0 && this.customerDetailBasicNew.cardNoSelected != "" && this.customerDetailBasicNew.storeIdSelected > 0) {
              this.customerInfoSrv.updateCardStore(this.customerDetailBasicNew.cardIdSelected, this.customerDetailBasicNew.cardNoSelected, this.customerDetailBasicNew.storeIdSelected).subscribe(resStore => {
                if(resStore){
                  self.translate.get(['common.saveSuccess']).subscribe(res => {
                    self.srvNotify.add({ severity: 'info', summary: 'Confirmed', detail: res['common.saveSuccess'] });
                    setTimeout(function () {
                      self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1, customerCode: customerCode } });
                    }, 200);
                  });
                }
              });
            }
          }

          /*** Modificato il 27/01/2022. Dopo che la modifica sarà ormai testata e utilizzata, cancellare questo commento per far pulizia ***/
          /*
          if(res && res.id) {
            let customerHostId: number = res.id;
            let customerCode: string = res.customerCode;
            this.customerInfoSrv.getVCustomerByHost(customerHostId.toString()).subscribe(res => {
              if(res && res.id){
                let vCustomerId: number = res.id;
                this.customerInfoSrv.addCard(vCustomerId, customerHostId, this.customerDetailBasicNew.cardIdSelected, this.customerDetailBasicNew.cardNoSelected).subscribe(res => {
                  if(res){

                    if(
                      res &&
                      this.customerDetailBasicNew.cardIdSelected>0 &&
                      this.customerDetailBasicNew.cardNoSelected!="" &&
                      this.customerDetailBasicNew.storeIdSelected > 0
                      ){
                        this.customerInfoSrv.updateCardStore(this.customerDetailBasicNew.cardIdSelected, this.customerDetailBasicNew.cardNoSelected,  this.customerDetailBasicNew.storeIdSelected).subscribe(resStore=>{
                          if(resStore){
                            self.translate.get(['common.saveSuccess']).subscribe(res => {
                              self.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: res['common.saveSuccess']});
                              setTimeout(function(){
                                self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1, customerCode: customerCode } });
                              },200);
                            });
                          }
                        });
                      }
                  }
                });
              }
            });
          }
          */
        });
      } else {
        this.customerDetailBasic.customSave().subscribe({
          next: (res) => {
            if (res) {
              self.translate.get(['common.saveSuccess']).subscribe(res => {
                self.srvNotify.add({ severity: 'info', summary: 'Confirmed', detail: res['common.saveSuccess'] });
                setTimeout(() => {
                  self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1 } });
                }, 200);
              });
            } else {
              self.translate.get(['common.validationError']).subscribe(res => {
                self.srvNotify.add({ severity: 'warn', summary: 'Validation', detail: res['common.validationError'] || 'Please correct the form errors.' });
              });
            }
          },
          error: (err) => {
            self.translate.get(['common.saveError']).subscribe(res => {
              self.srvNotify.add({ severity: 'error', summary: 'Error', detail: res['common.saveError'] || 'An error occurred while saving.' });
            });
          }
        });
      }
      return;
    }

    let customSaveEvent: Observable<any>;
    customSaveEvent = this.customerMgPermission ? this.customerDetailBasicNew.customSaveMg() : this.customerDetailBasic.customSave();

    customSaveEvent.switchMap((res) => {
      //se c'è qualche errore nel salvataggio

      if (!res) {
        return Observable.throw(this.activeTab.basicInfo);
      }

      if (!this.familyPermission) { return Observable.of(true); }

      return this.customerDetailFamily.customSave();
    }).switchMap((res) => {

      if (!res) {
        return Observable.throw(this.activeTab.familyInfo);
      }

      if (!this.hobbyPetPermission) { return Observable.of(true); }

      return this.customerDetailHobbyPerInfo.customSave();

    }).switchMap((res) => {
      if (!res) {
        return Observable.throw(this.activeTab.hobbyPetInfo);
      }
      return Observable.of(true);
    }).catch((e: number) => {
      console.log('Exception saving customer. tab idx', e);
      this.srvNotify.add({ severity: 'error', summary: `${this.errorTitle}!`, detail: `${this.errorSavingMsg}!` });
      this.activeTabIndex = e;
      return Observable.of(false);
    }).subscribe(res => {
      console.log('Save customer res:', res);
      this.customerClustersComponent.saveCustomerCluster();
      if (res) {
        self.translate.get(['common.updateSuccess']).subscribe(res => {
          self.srvNotify.add({ severity: 'info', summary: 'Confirmed', detail: res['common.updateSuccess'] });
          setTimeout(function () {
            if (self.customerMgPermission) {
              self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1, customerCode: self.basicInfo.customerCode } });
            } else {
              self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1 } });
            }
          }, 200);
        });
      }
    });
  }
  printReportMg() {

  }
  domiciliationDone() {
    if (this.customerMgPermission) {
      this.show.basic = false;
      this.show.uploadModule = false;
      var self = this;
      setTimeout(function () {
        self.show.basic = true;
        self.show.uploadModule = true;
      }, 100);
    }
  }
  basicInfoLoaded(basicInfo: CustomerBasicInfo) {
    this.basicInfo = basicInfo;
  }
  cardsInfoLoaded(cardInfo: CustomerCardListModel[]) {
    this.cardInfo = cardInfo;
  }
  checkFormData(dirtyFormData: boolean) {
    this.dirtyFormData = dirtyFormData;
  }

  clusterChangedHandler(event) {
    this.clusterChanged = event;
  }

  clusterListChangedHandler(event) {
    this.clusterQty = event.length;
  }

  confirm() {
    if (this.mdmCustomerPermission) {
      this.goBack();
    } else {
      // Andrebbe definita una param che stabilisca se la scheda cliente possa essere abbandonata anche senza cluster
      /*
      CASO FLUSSO GABRIELLI:
      non c'è bisogno di controlli su cluster.
      Gabrielli visualizza solo i cluster senza possibilità di aggiungere, modificare o eliminare.
      Bisogna solo salvare eventuali cambiamenti per l'allineamento con KLOY
      */
      if (this.customerMgPermission) {
        if (this.dirtyFormData) {
          this.confirmationService.confirm({
            message: this.dataLossMsg,
            accept: () => this.goBack(),
            acceptLabel: "Ok",
            rejectLabel: "Annulla",
            rejectVisible: true
          })
        } else {
          this.goBack()
        }
      }
      else {
        /*
         CASO FLUSSO NORMALE:
         c'è bisogno di aggiungere almeno un cluster e salvare in caso di cambiamenti
       */
        if (this.customerClusterCheck && (this.checkActiveCard() && this.clusterQty == 0)) {
          this.confirmationService.confirm({
            message: this.missingClusterMsg,
            accept: () => false,
            acceptLabel: "Ok",
            rejectVisible: false
          })
        } else if (this.clusterChanged) {
          this.confirmationService.confirm({
            message: this.saveClusterMsg,
            accept: () => false,
            acceptLabel: "Ok",
            rejectVisible: false
          })
        } else if (this.dirtyFormData) {
          this.confirmationService.confirm({
            message: this.dataLossMsg,
            accept: () => this.goBack(),
            acceptLabel: "Ok",
            rejectLabel: "Annulla",
            rejectVisible: true
          })
        } else {
          this.goBack();
        }
      }
    }
  }

  goBack() {
    if (this.basicInfo)
      this.router.navigate(['/customers-infosheet-new'], { queryParams: { customerCode: this.basicInfo.customerCode } });
    else
      this.location.back();
  }

  refreshCards() {
    this.customerInfoSrv.getCards(this.customerId).subscribe(res => this.cards = res);
  }

  checkActiveCard() {
    let active = false;
    if (this.cards && this.cards.length > 0) {
      this.cards.forEach(card => {
        if (card.flagBlackList == "0") {
          active = true
          return
        }
      })
    }
    return active;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/customer-detail.component.ts